import { Inject, Injectable } from '@angular/core';
import { IAuthenticationGuard } from "./i-authentication.guard";
import { HostUtil } from "../../../utils/host-util";
import { ICurrentUser } from "../../../models/i-current-user";
import {
    userAuthenticationRestClientInjectionToken
} from "../../../rest-clients/user/authentication/user-authentication-rest-client-injection-token";
import {
    IUserAuthenticationRestClient
} from "../../../rest-clients/user/authentication/i-user-authentication-rest.client";
import {
    sessionStateServiceInjectionToken
} from "../../../global-states/session/session-state-service-injection-token";
import { ISessionStateService } from "../../../global-states/session/i-session-state.service";

@Injectable()
export class AuthenticationGuard implements IAuthenticationGuard {
    constructor(
        @Inject(userAuthenticationRestClientInjectionToken) private readonly _userAuthenticationRestClient: IUserAuthenticationRestClient,
        @Inject(sessionStateServiceInjectionToken) private readonly _sessionStateService: ISessionStateService
    ) {
    }

  async isLoggedIn(): Promise<boolean> {
    const sessionStoredCurrentUser: ICurrentUser | null = this._sessionStateService.getCurrentUser();

    if (sessionStoredCurrentUser === null) {
      try {
        const currentUser: ICurrentUser = await this._userAuthenticationRestClient.getCurrentUser();
        const isLoggedIn: boolean = currentUser.email !== '';

        if (isLoggedIn) {
          return true;
        }

        location.href = HostUtil.getAuthenticationSiteUrl({"redirect": "developer-dashboard"});
        return false;
      } catch (e) {
        location.href = HostUtil.getAuthenticationSiteUrl({"redirect": "developer-dashboard"});
        return false;
      }
    } else {
      return Promise.resolve(true);
    }
  }
}
